import React from 'react'
import { Link } from 'react-router-dom'
import ScrollToTop from './ScrollToTop'

function Footer() {
  return (
    <footer>
      <ScrollToTop />
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className=" links ">
              <Link className="nav-link" to="/projects">
                Projects
              </Link>
              <Link className="nav-link" to="/howwework">
                How We Work
              </Link>
              <Link className="nav-link" to="/ourprinciples">
                Our Principles
              </Link>
              <Link className="nav-link" to="/ourpartnerships">
                Our Partnerships
              </Link>
            </div>
          </div>
          <div className="col-lg-6">
            <p className="copyright">
              Copyright © 2002-{new Date().getFullYear()} Freedom 22 Foundation. All Rights
              Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
